export default __webpack_public_path__ + "static/invest-header-c95a5cd17dd792cbaa06065d5d9e1530.jpg";